<template>
  <div
    v-if="!isMobile()"
    class="msboxwrapper"
    @pointerenter="wantNoteVideoPolicy"
    @focusin="wantNoteVideoPolicy"
  >
    <div class="container">
      <div class="mboxtitle col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="header-title" :id="'dragHeader' + patientKey">
          <h2 class="notesTitle">
            <b>{{ patient.first_name + " " + patient.lastname }} ({{ patient.date_of_birth }})</b>
          </h2>
        </div>
        <div class="header-first">
          <select id="note-type" class="note-type" v-model="noteType">
            <option value="Nursing">Nursing Note</option>
            <option value="Providers">Providers Note</option>
            <option value="Home Health Aid">Home Health Aid Note</option>
            <option value="Allied Professional">Allied Professional Note</option>
            <option value="Geriatric Care Manager">Geriatric Care Manager Note</option>
            <option v-if="$route.name == 'MedAdminNavigation'" value="9898X">
              Therapeutic Monitoring (CPT 9897X)
            </option>
            <option v-if="$route.name == 'VitalsGroup'" value="9945X">
              Physiologic Monitoring (CPT 9945X)
            </option>
          </select>
          <div class="startDateTime">
            <b
              >{{ startDateLabel }}
            </b>
            <input type="date" id="startDt" name="startDt" v-model="startDt" required />
            <input type="time" id="startTime" name="startTime" v-model="timeChild" required />
          </div>
        </div>
        <div
          v-if="isCaregiverVisitNote"
          class="header-second"
        >
          <div class="endDateTime">
            <b>End </b>
            <input type="date" id="endDt" name="endDt" v-model="endDt" required />
            <input type="time" id="endTime" name="endTime" v-model="endTime" required />
          </div>
        </div>
        <!-- <span class="noteTimer" v-if="noteType == 'Vitals' || noteType == '9898X' || noteType == '9945X'">{{ showTime() }}</span> -->
        <div id="msglbl" class="notemsglbl"></div>
      </div>
      <div class="msgbox col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <form action="" method="POST">
          <!-- <editor
            v-model="message"
            api-key="wtyerkxnsy7pxhf40g1mq9tjlifsy2ygztyau951df686zv9"
            :init="{
              height: 300,
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'help',
                'wordcount',
              ],
              toolbar:
                'undo redo | casechange blocks | bold italic backcolor | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'bullist numlist checklist outdent indent | removeformat | code table help',
            }"
          /> -->
          <!-- Put it in a shell for resizing capabilities -->
          <div class="note-editor-shell">
            <EditorComponent v-model="message" editorStyle="height: 100%">
              <template #toolbar>
                <span class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                  <button class="ql-underline"></button>
                </span>
              </template>
            </EditorComponent>
          </div>
          <note-video-attach
            v-if="noteVideoAvailable"
            :entries="noteVideoEntries"
            :accept="noteVideoAccept"
            :full="noteVideoFull"
            :busy="noteVideosBusy"
            @pick="onNoteVideosPicked"
            @upload-action="onNoteVideoAction"
            @visible-change="onNoteVideoVisible"
          />
          <div class="last-note-title">
            <span>Latest {{ this.noteType }} Notes</span>
          </div>
          <div v-if="noteList.length != 0" class="note-list">
            <div
              v-for="(note, index) in filterNotes()"
              class="note-item"
              @click="showContents(note)"
              :key="'note' + index"
            >
              <span class="noteList-left">{{ note.startDt }}</span>
              <span
                v-if="noteVideoCountLabel(note)"
                class="noteList-videos"
                data-test="note-video-count"
              >{{ noteVideoCountLabel(note) }}</span>
              <span class="noteList-right">{{ note.name }}</span>
            </div>
          </div>
          <span
            class="noteTimer"
            v-if="noteType == 'Vitals' || noteType == '9898X' || noteType == '9945X'"
            >{{ showTime() }}</span
          >
          <div class="note-template-notify-row">
            <select
              id="template-chooser"
              class="template-chooser"
              v-model="noteTemplateSelector"
              @change="applySelectedTemplate"
            >
              <option value="Templates">Templates</option>
              <option v-for="template in noteTemplates" :key="template.id" :value="String(template.id)">
                {{ template.name }}
              </option>
            </select>
            <!-- Center column: group/individual picker sits on the modal midpoint. -->
            <div class="notify-pickers">
              <div
                class="notify-picker notify-picker--combined"
                :class="{ 'notify-picker--expanded': notifyPickerExpanded }"
              >
                <div class="notify-recipients-header">
                  <span class="notify-recipients-label" id="notify-recipients-label">Notify</span>
                  <!-- Collapsed by default so the modal stays shorter; expand to pick groups. -->
                  <button
                    v-if="orderedNotifyGroups.length"
                    type="button"
                    class="notify-recipients-toggle"
                    :aria-expanded="notifyPickerExpanded"
                    aria-controls="notify-recipients-list"
                    @click="toggleNotifyPicker"
                  >
                    {{ notifyPickerExpanded ? "Show less" : "Show more" }}
                  </button>
                </div>
                <div
                  v-show="notifyPickerExpanded"
                  id="notify-recipients-list"
                  class="notify-combined"
                  role="group"
                  aria-labelledby="notify-recipients-label"
                >
                  <p v-if="!orderedNotifyGroups.length" class="notify-combined__empty">
                    No groups available
                  </p>
                  <div
                    v-for="group in orderedNotifyGroups"
                    :key="group.group_id"
                    class="notify-combined__group"
                  >
                    <label class="notify-combined__group-row">
                      <input
                        type="checkbox"
                        :checked="isNotifyGroupSelected(group.group_id)"
                        @change="toggleNotifyGroup(group.group_id, $event.target.checked)"
                      />
                      <span class="notify-combined__group-name">{{ group.group_name }}</span>
                      <span
                        v-if="!isSystemDefaultNotifyGroup(group)"
                        class="notify-combined__badge"
                      >Custom</span>
                    </label>
                    <label
                      v-for="member in group.members || []"
                      :key="`${group.group_id}-${member.unique_ID || member.id}`"
                      class="notify-combined__member-row"
                      :class="{
                        'notify-combined__member-row--covered': isNotifyGroupSelected(group.group_id),
                      }"
                    >
                      <input
                        type="checkbox"
                        :checked="isNotifyMemberSelected(member.unique_ID || member.id)"
                        :disabled="isNotifyGroupSelected(group.group_id)"
                        @change="
                          toggleNotifyMember(
                            member.unique_ID || member.id,
                            $event.target.checked
                          )
                        "
                      />
                      <span>{{ member.name }}</span>
                    </label>
                    <p
                      v-if="!(group.members && group.members.length)"
                      class="notify-combined__no-members"
                    >
                      No members
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Right of picker: plaintext recipient preview (not an input-styled box). -->
            <aside
              class="notify-selection-panel"
              :class="{ 'notify-selection-panel--collapsed': !notifyPickerExpanded }"
              aria-live="polite"
            >
              <p v-if="resolvedNotifyMembers.length" class="notify-selection-panel__text">
                Will notify:
                <strong
                  v-for="(member, index) in resolvedNotifyMembers"
                  :key="'notify-preview-' + (member.unique_ID || member.id || member.name)"
                >
                  {{ member.name }}<template v-if="index < resolvedNotifyMembers.length - 1">, </template>
                </strong>
              </p>
              <p
                v-else-if="hasNotifySelection"
                class="notify-selection-panel__text notify-selection-panel__text--muted"
              >
                No reachable recipients in the current selection
              </p>
              <p
                v-else
                class="notify-selection-panel__text notify-selection-panel__text--muted"
              >
                No recipients selected
              </p>
            </aside>
          </div>
          <div class="note-signature">
            <div class="provsig-wrapper">
              <div class="provname">
                <label>Signature:</label>
                <input
                  class="satisfy-regular"
                  type="text"
                  v-model="provsignature"
                  id="provsigname"
                />
              </div>
              <div class="provsigdate">
                <label>Signature Date:</label
                ><input type="date" v-model="provsigdt" id="provdatefld" />
              </div>
            </div>
          </div>
          <div class="note-footer-row">
            <div class="note-footer-left">
              <input
                type="button"
                value="Make Template"
                :class="[
                  'modaldraftbtn',
                  'template-footer-btn',
                  { 'template-footer-btn--disabled': !canMakeTemplate },
                ]"
                :disabled="!canMakeTemplate"
                @click="openTemplateModal('create')"
              />
              <input
                type="button"
                value="Edit Template"
                :class="[
                  'modaldraftbtn',
                  'template-footer-btn',
                  { 'template-footer-btn--disabled': !canEditTemplate },
                ]"
                :disabled="!canEditTemplate"
                @click="openTemplateModal('edit')"
              />
              <input
                type="button"
                :value="selectedTemplate ? `Delete ${selectedTemplate.name}` : 'Delete Template'"
                :class="[
                  'modaldraftbtn',
                  'template-footer-btn',
                  'template-footer-btn--delete',
                  { 'template-footer-btn--disabled': !canEditTemplate },
                ]"
                :disabled="!canEditTemplate"
                @click="deleteTemplate"
              />
            </div>
            <div class="note-footer-right">
              <div class="note-notify-stack" aria-label="Patient notification options">
                <div class="note-notify-label-row">
                  <label for="notifyptchkbx" class="note-notify-label">E-mail Patient</label>
                  <label for="notifyptchkbx2" class="note-notify-label">Text Patient</label>
                </div>
                <div class="note-notify-check-row">
                  <span class="note-notify-check-cell">
                    <input type="checkbox" id="notifyptchkbx" v-model="notify" />
                  </span>
                  <span class="note-notify-check-cell">
                    <input type="checkbox" id="notifyptchkbx2" v-model="notifysms" />
                  </span>
                </div>
              </div>
              <div class="note-footer-actions">
                <input
                  type="button"
                  value="Cancel"
                  id="cnclbtn"
                  class="modalcancelbtn"
                  @click="removeNote"
                />
                <input
                  type="button"
                  value="Save Draft"
                  id="draftbtn"
                  class="modaldraftbtn"
                  @click="draftNote"
                />
                <input
                  type="button"
                  value="Save"
                  id="msgbtn"
                  class="modalbtn"
                  :disabled="noteVideosBusy"
                  @click="saveNote"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="popupText" class="text-popup eh-popup-overlay">
      <div class="outer-container">
        <div class="text-content">
          <p v-html="popupText"></p>
          <note-attachment-list :note="popupNote" />
        </div>
      </div>
      <div class="btn-group">
        <button type="button" class="notebtn btn btn-secondary" @click="closeContents">
          Close
        </button>
      </div>
    </div>
    <div v-if="templateModalOpen" class="text-popup eh-popup-overlay">
      <div class="template-modal-content eh-popup-panel">
        <h3>{{ templateModalMode === "edit" ? "Edit Template" : "Make Template" }}</h3>
        <label for="templateNameInput">Template Name</label>
        <input
          id="templateNameInput"
          type="text"
          v-model="templateFormName"
          class="template-name-input"
          placeholder="Enter template name"
        />
        <div class="template-modal-actions">
          <button
            v-if="templateModalMode === 'edit'"
            type="button"
            class="template-modal-btn delete"
            :disabled="templateSaving"
            @click="deleteTemplate"
          >
            Delete {{ selectedTemplate?.name }}
          </button>
          <button type="button" class="template-modal-btn cancel" @click="closeTemplateModal">
            Cancel
          </button>
          <button
            type="button"
            class="template-modal-btn save"
            :disabled="templateSaving"
            @click="saveTemplate"
          >
            {{ templateSaving ? "Saving..." : "Save" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="Mobile-container"
    @pointerenter="wantNoteVideoPolicy"
    @focusin="wantNoteVideoPolicy"
  >
    <h2 class="Mobile-title">
      {{ `${patient.first_name} ${patient.lastname} (${patient.date_of_birth})` }}
    </h2>
    <div class="Mobile-form-group Mobile-form-row">
      <label for="noteType">Note Type:</label>
      <select v-model="noteType" id="noteType" class="Mobile-select">
        <option value="Nursing">Nursing Note</option>
        <option value="Providers">Providers Note</option>
        <option value="Home Health Aid">Home Health Aid Note</option>
        <option value="Allied Professional">Allied Professional Note</option>
        <option value="Geriatric Care Manager">Geriatric Care Manager Note</option>
        <option v-if="$route.name == 'MedAdminNavigation'" value="9898X">
          Therapeutic Monitoring (CPT 9897X)
        </option>
        <option v-if="$route.name == 'VitalsGroup'" value="9945X">
          Physiologic Monitoring (CPT 9945X)
        </option>
      </select>
    </div>
    <!-- Templates sit right under note type on mobile to keep the form compact. -->
    <div class="Mobile-form-group Mobile-form-row">
      <label for="templatesMobile">Templates:</label>
      <select
        v-model="noteTemplateSelector"
        @change="applySelectedTemplate"
        id="templatesMobile"
        class="Mobile-select"
      >
        <option value="Templates">Templates</option>
        <option v-for="template in noteTemplates" :key="template.id" :value="String(template.id)">
          {{ template.name }}
        </option>
      </select>
    </div>
    <div class="Mobile-form-group Mobile-form-row">
      <label for="startDtMobile">{{ startDateLabel }}:</label>
      <div class="Mobile-inline-inputs">
        <input required v-model="startDt" type="date" id="startDtMobile" class="Mobile-input" />
        <input required v-model="timeChild" type="time" id="startTimeMobile" class="Mobile-input" />
      </div>
    </div>
    <div v-if="isCaregiverVisitNote" class="Mobile-form-group Mobile-form-row">
      <label for="endDtMobile">End:</label>
      <div class="Mobile-inline-inputs">
        <input required v-model="endDt" type="date" id="endDtMobile" class="Mobile-input" />
        <input required v-model="endTime" type="time" id="endTimeMobile" class="Mobile-input" />
      </div>
    </div>
    <div class="Mobile-form-group Mobile-note-header">
      <label for="noteContent">Note Content:</label>
      <div class="Mobile-note-control">
        <button
          id="expandButton"
          @click="
            expanded = true;
            expandMsg = message;
          "
        >
          +
        </button>
        <span class="Mobile-create-note">Expand Note</span>
      </div>
    </div>
    <div class="Mobile-form-group">
      <!-- Put it in a shell for resizing capabilities -->
      <div class="note-editor-shell Mobile-textarea">
        <EditorComponent
          id="noteContent"
          v-model="message"
          editorStyle="height: 100%"
        >
          <template #toolbar>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
            </span>
          </template>
        </EditorComponent>
      </div>
    </div>
    <note-video-attach
      v-if="noteVideoAvailable"
      :entries="noteVideoEntries"
      :accept="noteVideoAccept"
      :full="noteVideoFull"
      :busy="noteVideosBusy"
      @pick="onNoteVideosPicked"
      @upload-action="onNoteVideoAction"
      @visible-change="onNoteVideoVisible"
    />
    <div class="Mobile-form-group">
      <h3>Latest {{ this.noteType }} Notes</h3>
      <div v-if="noteList.length != 0">
        <div
          v-for="(note, index) in filterNotes()"
          class="mobile-note-item"
          @click="showContentsMobile(note.pnotes, index)"
          :key="'note' + index"
        >
          <div class="note-meta-mobile">
            <span>{{ note.startDt }}</span>
            <span
              v-if="noteVideoCountLabel(note)"
              data-test="note-video-count"
            >{{ noteVideoCountLabel(note) }}</span>
            <span>{{ note.name }}</span>
          </div>
          <div class="mobile-note-content" :id="'notecontent' + index">
            <p v-html="note.pnotes" />
            <note-attachment-list :note="note" />
          </div>
        </div>
      </div>
    </div>
    <div class="Mobile-form-group mobileNoteTimer">
      <span v-if="noteType == 'Vitals' || noteType == '9898X' || noteType == '9945X'">
        {{ showTime() }}
      </span>
    </div>
    <div class="Mobile-form-group">
      <div class="notify-recipients-header notify-recipients-header--mobile">
        <label id="selectNotifyMobileLabel">Notify:</label>
        <button
          v-if="orderedNotifyGroups.length"
          type="button"
          class="notify-recipients-toggle notify-recipients-toggle--mobile"
          :aria-expanded="notifyPickerExpanded"
          aria-controls="notify-recipients-list-mobile"
          @click="toggleNotifyPicker"
        >
          {{ notifyPickerExpanded ? "Show less" : "Show more" }}
        </button>
      </div>
      <div
        v-show="notifyPickerExpanded"
        id="notify-recipients-list-mobile"
        class="notify-combined notify-combined--mobile"
        role="group"
        aria-labelledby="selectNotifyMobileLabel"
      >
        <p v-if="!orderedNotifyGroups.length" class="notify-combined__empty">
          No groups available
        </p>
        <div
          v-for="group in orderedNotifyGroups"
          :key="'m-' + group.group_id"
          class="notify-combined__group"
        >
          <label class="notify-combined__group-row">
            <input
              type="checkbox"
              :checked="isNotifyGroupSelected(group.group_id)"
              @change="toggleNotifyGroup(group.group_id, $event.target.checked)"
            />
            <span class="notify-combined__group-name">{{ group.group_name }}</span>
            <span
              v-if="!isSystemDefaultNotifyGroup(group)"
              class="notify-combined__badge"
            >Custom</span>
          </label>
          <label
            v-for="member in group.members || []"
            :key="`m-${group.group_id}-${member.unique_ID || member.id}`"
            class="notify-combined__member-row"
            :class="{
              'notify-combined__member-row--covered': isNotifyGroupSelected(group.group_id),
            }"
          >
            <input
              type="checkbox"
              :checked="isNotifyMemberSelected(member.unique_ID || member.id)"
              :disabled="isNotifyGroupSelected(group.group_id)"
              @change="
                toggleNotifyMember(member.unique_ID || member.id, $event.target.checked)
              "
            />
            <span>{{ member.name }}</span>
          </label>
          <p
            v-if="!(group.members && group.members.length)"
            class="notify-combined__no-members"
          >
            No members
          </p>
        </div>
      </div>
      <p v-if="hasNotifySelection" class="group-members-preview group-members-preview--mobile">
        <template v-if="resolvedNotifyMembers.length">
          Will notify: {{ selectedNotifyMemberNames }}
        </template>
        <template v-else>
          No reachable recipients in the current selection
        </template>
      </p>
    </div>
    <div class="Mobile-form-group note-signature Mobile-note-signature">
      <div class="provsig-wrapper">
        <div class="provname Mobile-form-row">
          <label for="provsignameMobile">Signature:</label>
          <input
            class="satisfy-regular Mobile-signature-input"
            type="text"
            v-model="provsignature"
            id="provsignameMobile"
          />
        </div>
        <div class="provsigdate Mobile-form-row">
          <label for="provdatefldMobile">Signature Date:</label>
          <input type="date" v-model="provsigdt" id="provdatefldMobile" class="Mobile-input" />
        </div>
      </div>
    </div>
    <div class="mobile-template-action-row">
      <button
        type="button"
        class="template-action-btn"
        :disabled="!canMakeTemplate"
        @click="openTemplateModal('create')"
      >
        Make Template
      </button>
      <button
        type="button"
        class="template-action-btn"
        :disabled="!canEditTemplate"
        @click="openTemplateModal('edit')"
      >
        Edit Template
      </button>
      <button
        type="button"
        class="template-action-btn template-action-btn--delete"
        :disabled="!canEditTemplate"
        @click="deleteTemplate"
      >
        {{ selectedTemplate ? `Delete ${selectedTemplate.name}` : "Delete Template" }}
      </button>
    </div>
    <div class="Mobile-notify-block">
      <div class="note-notify-stack" aria-label="Patient notification options">
        <div class="note-notify-label-row">
          <label for="notifyptchkbxMobile" class="note-notify-label">E-mail Patient</label>
          <label for="notifyptchkbx2Mobile" class="note-notify-label">Text Patient Text</label>
        </div>
        <div class="note-notify-check-row">
          <span class="note-notify-check-cell">
            <input type="checkbox" id="notifyptchkbxMobile" v-model="notify" />
          </span>
          <span class="note-notify-check-cell">
            <input type="checkbox" id="notifyptchkbx2Mobile" v-model="notifysms" />
          </span>
        </div>
      </div>
    </div>
    <div class="Mobile-button-group">
      <button class="Mobile-button Mobile-cancel" @click="removeNote">Cancel</button>
      <button class="Mobile-button Mobile-save-draft" @click="draftNote">
        Save Draft
      </button>
      <button class="Mobile-button Mobile-save" :disabled="noteVideosBusy" @click="saveNote">Save</button>
    </div>
    <div v-if="expanded" id="newNoteModal" class="mobile-modal eh-popup-overlay">
      <div class="mobile-modal-content eh-popup-panel">
        <div class="mobile-modal-header">
          <h2 class="mobile-modal-name">
            {{ `${patient.first_name} ${patient.lastname} (${patient.date_of_birth})` }}
          </h2>
          <button
            @click="
              expanded = false;
              message = expandMsg;
            "
            class="mobile-close-modal"
          >
            Close
          </button>
        </div>
        <EditorComponent
          id="mobile-new-note-content"
          class="mobile-textarea-fullscreen"
          v-model="expandMsg"
          editorStyle="height: 90%"
        >
          <template #toolbar>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
            </span>
          </template>
        </EditorComponent>
      </div>
    </div>
    <div v-if="templateModalOpen" class="text-popup eh-popup-overlay">
      <div class="template-modal-content eh-popup-panel">
        <h3>{{ templateModalMode === "edit" ? "Edit Template" : "Make Template" }}</h3>
        <label for="templateNameInputMobile">Template Name</label>
        <input
          id="templateNameInputMobile"
          type="text"
          v-model="templateFormName"
          class="template-name-input"
          placeholder="Enter template name"
        />
        <div class="template-modal-actions">
          <button
            v-if="templateModalMode === 'edit'"
            type="button"
            class="template-modal-btn delete"
            :disabled="templateSaving"
            @click="deleteTemplate"
          >
            Delete {{ selectedTemplate?.name }}
          </button>
          <button type="button" class="template-modal-btn cancel" @click="closeTemplateModal">
            Cancel
          </button>
          <button
            type="button"
            class="template-modal-btn save"
            :disabled="templateSaving"
            @click="saveTemplate"
          >
            {{ templateSaving ? "Saving..." : "Save" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import { getNotes, deleteNotes, updateNotes } from "@/api/userApi";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { h } from 'vue'
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { sessionActorFrom } from "@/utils/sessionIdentity";
import { isCaregiverNoteType } from "@/constants/noteTypes";
import NoteAttachmentList from "@/components/includes/attachments/NoteAttachmentList.vue";
import NoteVideoAttach from "@/components/includes/attachments/NoteVideoAttach.vue";
import noteVideoMixin from "@/components/includes/attachments/noteVideoMixin";
import { saveNote as postNote } from "@/api/notesApi";
import {
  NOTE_VIDEO_UPLOADING_TEXT,
  noteVideoCount,
  notePatientId,
  videoCountLabel,
} from "@/utils/noteAttachments";

// Patient-owned default subgroup names (from proto templates). Anything else is "custom".
const SYSTEM_DEFAULT_NOTIFY_GROUP_NAMES = new Set([
  "contacts",
  "family", // legacy rename → Contacts
  "providers",
  "nurses",
  "home health aids",
  "allied professionals",
  "geriatric care managers",
  "patients",
]);

export default {
  name: "NotePopup",
  components: { NoteAttachmentList, NoteVideoAttach },
  mixins: [noteVideoMixin],
  data() {
    return {
      message: "",
      notify: false,
      notifysms:false,
      startDt: null,
      endDt: null,
      startTime: null,
      endTime: null,
      noteTemplateSelector: "Templates",
      noteTemplates: [],
      noteList: [],
      popupText: "",
      // The note whose overlay is open: its videos are shown beside popupText.
      popupNote: null,
      noteType: this.type,
      // Patient proto groups from GetPatientTeamForMessaging (array, not old provider map).
      groupList: [],
      // Selected group ids (strings). Empty + no individuals → no care-team notify.
      selectedNotifyGroupIds: [],
      // Explicit individual unique_IDs (not already covered by a selected group).
      selectedNotifyMemberIds: [],
      // Notify group/member checklist starts collapsed to save modal height.
      notifyPickerExpanded: false,
      runningTime: 0,
      interval: null,
      expanded: false,
      expandMsg: "",
      provsignature: "",
      provsigdt: "",
      timeChild: this.time,
      templateModalOpen: false,
      templateModalMode: "create",
      templateFormName: "",
      templateSaving: false,
    };
  },
  props: {
    patient: {},
    type: String,
    time: String,
    pEmail:String
  },
  async mounted() {
    let date = new Date();
    let today = date.toISOString().substring(0, 10);
    this.startDt = today;
    this.endDt = today;
    //lets set the Providers signature here (logged-in actor, not chart subject)
    this.provsignature = this.sessionActor.displayName;
    this.provsigdt = today;
    // this.startTime = this.time
    // let tmpTime = date.toLocaleTimeString('en-US', { hour12: false}).slice(0, -3)
    // this.startTime = tmpTime.length == 7 ? `0${tmpTime}` : tmpTime

    // let noteGetter = {
    //   userid: this.user.id,
    //   patientid: this.patient.id + "",
    // };
    // getNotes(noteGetter).then((res) => {
    //   if (res[0]) {
    //     if (res[0].data2) {
    //       this.message = res[0].data2;
    //     }
    //     if (res[0].data) {
    //       let dates = JSON.parse(res[0].data);
    //       this.startDt = dates.startDt;
    //       this.endDt = dates.endDt;
    //       this.startTime = dates.startTime;
    //       this.endTime = dates.endTime;
    //     }
    //   }
    // });
    if (this.patient && (this.patient.patient_id || this.patient.psersonalID || this.patient.id)) {
      this.getAllNotes();
      this.loadTemplates();
      this.getGroups();
    }
    const notePopup = document.getElementById("note__popup" + this.patientKey);
    if (notePopup) {
      this.dragNote(notePopup);
    }
  },
  computed: {
    ...mapGetters("login", {
      user: "getUser",
    }),
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    sessionActor() {
      return sessionActorFrom(this.allData, useSessionSelfStore().profile);
    },
    patientKey() {
      return this.patient?.patient_id || this.patient?.psersonalID || this.patient?.id || this.patient?.externId || "";
    },
    selectedTemplate() {
      if (this.noteTemplateSelector === "Templates") {
        return null;
      }
      return this.noteTemplates.find((template) => String(template.id) === String(this.noteTemplateSelector)) || null;
    },
    canMakeTemplate() {
      return this.hasTemplateContent(this.message);
    },
    canEditTemplate() {
      return !!this.selectedTemplate;
    },
    isCaregiverVisitNote() {
      return isCaregiverNoteType(this.noteType);
    },
    startDateLabel() {
      return this.isCaregiverVisitNote ? "Start" : "Date";
    },
    // Deduped care-team roster: all members across patient-owned subgroups.
    teamMembers() {
      const byUid = {};
      // Walk every patient-owned group and collect unique people.
      for (const group of this.groupList || []) {
        for (const member of group.members || []) {
          const uid = String(member.unique_ID || member.id || "").trim();
          if (!uid || byUid[uid]) continue; // skip blanks / duplicates
          byUid[uid] = {
            unique_ID: uid,
            name: String(member.name || "").trim() || uid,
            email: member.email || "",
            phone: member.phone || "",
            communication_preference: member.communication_preference || "",
          };
        }
      }
      return Object.values(byUid).sort((a, b) =>
        String(a.name).localeCompare(String(b.name), undefined, { sensitivity: "base" })
      );
    },
    // Custom groups first (A→Z), then system defaults (A→Z).
    orderedNotifyGroups() {
      const groups = Array.isArray(this.groupList) ? [...this.groupList] : [];
      const nameCmp = (a, b) =>
        String(a.group_name || "").localeCompare(String(b.group_name || ""), undefined, {
          sensitivity: "base",
        });
      const custom = groups.filter((g) => !this.isSystemDefaultNotifyGroup(g)).sort(nameCmp);
      const system = groups.filter((g) => this.isSystemDefaultNotifyGroup(g)).sort(nameCmp);
      return [...custom, ...system];
    },
    // Map of unique_ID → member for everyone in currently selected groups.
    membersFromSelectedGroups() {
      const byUid = {};
      // Fast lookup of which group ids the user picked.
      const selected = new Set((this.selectedNotifyGroupIds || []).map(String));
      for (const group of this.groupList || []) {
        if (!selected.has(String(group.group_id))) continue; // ignore unselected groups
        for (const member of group.members || []) {
          const uid = String(member.unique_ID || member.id || "").trim();
          if (uid) byUid[uid] = member; // last write wins; same person in 2 groups is fine
        }
      }
      return byUid;
    },
    // True when at least one group or individual is selected for notify.
    hasNotifySelection() {
      return (
        (Array.isArray(this.selectedNotifyGroupIds) && this.selectedNotifyGroupIds.length > 0) ||
        (Array.isArray(this.selectedNotifyMemberIds) && this.selectedNotifyMemberIds.length > 0)
      );
    },
    // Final recipient list: selected groups ∪ explicit individuals (deduped).
    resolvedNotifyMembers() {
      // Seed with everyone implied by selected groups.
      const byUid = { ...this.membersFromSelectedGroups };
      // Index the full team so we can resolve hand-picked ids to member objects.
      const teamByUid = {};
      for (const member of this.teamMembers) {
        teamByUid[member.unique_ID] = member;
      }
      // Add any hand-picked people not already covered by a group.
      for (const uid of this.selectedNotifyMemberIds || []) {
        const id = String(uid || "").trim();
        if (!id || byUid[id]) continue;
        if (teamByUid[id]) byUid[id] = teamByUid[id];
      }
      return Object.values(byUid);
    },
    // Comma-separated names for the "Will notify" preview line.
    selectedNotifyMemberNames() {
      return this.resolvedNotifyMembers
        .map((member) => String(member.name || "").trim())
        .filter(Boolean)
        .join(", ");
    },
    // Numeric group ids ready for the notify API payload.
    notifyGroupIdsForApi() {
      return (this.selectedNotifyGroupIds || [])
        .map((id) => Number(id))
        .filter((id) => id > 0);
    },
    // Explicit individual ids not already implied by a selected group.
    notifyMemberIdsForApi() {
      const covered = new Set(Object.keys(this.membersFromSelectedGroups));
      return (this.selectedNotifyMemberIds || [])
        .map((id) => String(id || "").trim())
        .filter((uid) => uid && !covered.has(uid)); // avoid double-sending group members
    },
  },
  methods: {
    // True when the group is a system default subgroup (Contacts, Providers, …), not user-created.
    isSystemDefaultNotifyGroup(group) {
      const n = String(group?.group_name || "")
        .trim()
        .toLowerCase();
      return n !== "" && SYSTEM_DEFAULT_NOTIFY_GROUP_NAMES.has(n);
    },
    // True when this group id is in the Notify picker's selected groups.
    isNotifyGroupSelected(groupId) {
      const id = String(groupId || "").trim();
      return id !== "" && (this.selectedNotifyGroupIds || []).map(String).includes(id);
    },
    // True when the member is selected directly or covered by a selected group.
    isNotifyMemberSelected(uniqueId) {
      const uid = String(uniqueId || "").trim();
      if (!uid) return false;
      if (Object.prototype.hasOwnProperty.call(this.membersFromSelectedGroups, uid)) return true;
      return (this.selectedNotifyMemberIds || []).map(String).includes(uid);
    },
    // Check/uncheck a whole group; prune explicit member picks now covered by group selection.
    toggleNotifyGroup(groupId, checked) {
      const id = String(groupId || "").trim();
      if (!id) return;
      const next = new Set((this.selectedNotifyGroupIds || []).map(String));
      if (checked) next.add(id);
      else next.delete(id);
      this.selectedNotifyGroupIds = Array.from(next);
      // Drop explicit picks that are now covered by selected groups.
      const covered = new Set(Object.keys(this.membersFromSelectedGroups));
      this.selectedNotifyMemberIds = (this.selectedNotifyMemberIds || []).filter(
        (uid) => !covered.has(String(uid))
      );
    },
    // Check/uncheck one person when their parent group is not selected (rows are disabled if it is).
    toggleNotifyMember(uniqueId, checked) {
      const uid = String(uniqueId || "").trim();
      if (!uid) return;
      // Covered by a selected group — member rows are disabled in the UI.
      if (Object.prototype.hasOwnProperty.call(this.membersFromSelectedGroups, uid)) return;
      const next = new Set((this.selectedNotifyMemberIds || []).map(String));
      if (checked) next.add(uid);
      else next.delete(uid);
      this.selectedNotifyMemberIds = Array.from(next);
    },
    // Expand/collapse the combined Notify groups checklist.
    toggleNotifyPicker() {
      this.notifyPickerExpanded = !this.notifyPickerExpanded;
    },
    hasTemplateContent(content) {
      const normalized = String(content || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/g, " ")
        .trim();
      return normalized.length > 0;
    },
    async loadTemplates() {
      // HomeGrid rows expose patient_id (= psersonalID); /notes GetCurrentPatientData does not.
      const patientId = this.patientKey;
      const accountNumber =
        this.allData?.patient?.externId2 ||
        this.patient?.accountnumber ||
        this.patient?.externId2 ||
        "";
      if (!patientId) {
        this.noteTemplates = [];
        this.noteTemplateSelector = "Templates";
        return;
      }
      const content = {
        Note: {
          API_Meth: "GetNoteTemplates",
          accountnumber: accountNumber,
          patientID: patientId,
        },
      };
      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        });
        this.noteTemplates = Array.isArray(res?.data?.data) ? res.data.data : [];
      } catch (err) {
        console.error("Unable to load note templates", err);
        this.noteTemplates = [];
      }
      if (
        this.noteTemplateSelector !== "Templates" &&
        !this.noteTemplates.some((template) => String(template.id) === String(this.noteTemplateSelector))
      ) {
        this.noteTemplateSelector = "Templates";
      }
    },
    applySelectedTemplate() {
      if (!this.selectedTemplate) {
        return;
      }
      this.message = this.selectedTemplate.body_html || "";
    },
    openTemplateModal(mode) {
      if (mode === "create" && !this.canMakeTemplate) {
        return;
      }
      if (mode === "edit" && !this.canEditTemplate) {
        return;
      }
      this.templateModalMode = mode;
      this.templateFormName = mode === "edit" ? (this.selectedTemplate?.name || "") : "";
      this.templateModalOpen = true;
    },
    closeTemplateModal() {
      this.templateModalOpen = false;
      this.templateFormName = "";
      this.templateSaving = false;
    },
    async saveTemplate() {
      // Same ID resolution as loadTemplates / note save (patient_id or psersonalID).
      const patientId = this.patientKey;
      const accountNumber =
        this.allData?.patient?.externId2 ||
        this.patient?.accountnumber ||
        this.patient?.externId2 ||
        "";
      const trimmedName = String(this.templateFormName || "").trim();
      if (!patientId) {
        alert("Patient was not found for this note.");
        return;
      }
      if (!accountNumber) {
        alert("Account number was not found for this note.");
        return;
      }
      if (!trimmedName) {
        alert("Please enter a template name.");
        return;
      }
      const isEdit = this.templateModalMode === "edit";
      // Create seeds the template body from the current note; edit is a rename and
      // keeps the saved template body untouched (the modal only exposes the name).
      if (!isEdit && !this.hasTemplateContent(this.message)) {
        alert("There is no note content to save as template.");
        return;
      }
      this.templateSaving = true;
      const actorId = this.allData?.manager?.externid || "";
      const payload = {
        Note: {
          API_Meth: isEdit ? "UpdateNoteTemplate" : "CreateNoteTemplate",
          accountnumber: accountNumber,
          patientID: patientId,
          name: trimmedName,
          bodyHtml: isEdit ? (this.selectedTemplate?.body_html || "") : this.message,
          updatedBy: actorId,
          ...(isEdit
            ? { templateID: this.selectedTemplate?.id }
            : { createdBy: actorId }),
        },
      };
      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", payload, {
          headers: { "Content-Type": "application/json;" },
        });
        if (res?.data?.status !== "success") {
          throw new Error(res?.data?.message || "Template save failed");
        }
        const newTemplateId =
          !isEdit && res?.data?.id ? String(res.data.id) : String(this.selectedTemplate?.id || "");
        await this.loadTemplates();
        if (newTemplateId) {
          this.noteTemplateSelector = newTemplateId;
          // Only load the body into the editor when creating; a rename must not
          // overwrite the note the provider is currently writing.
          if (!isEdit) {
            this.applySelectedTemplate();
          }
        }
        this.closeTemplateModal();
      } catch (err) {
        console.error("Unable to save template", err);
        alert("Unable to save the template. Please try again.");
      } finally {
        this.templateSaving = false;
      }
    },
    async deleteTemplate() {
      const template = this.selectedTemplate;
      if (!template) {
        return;
      }
      const patientId = this.patientKey;
      const accountNumber =
        this.allData?.patient?.externId2 ||
        this.patient?.accountnumber ||
        this.patient?.externId2 ||
        "";
      if (!patientId || !accountNumber) {
        alert("Patient or account was not found for this note.");
        return;
      }
      if (!window.confirm(`Delete template "${template.name}"? This cannot be undone.`)) {
        return;
      }
      this.templateSaving = true;
      const payload = {
        Note: {
          API_Meth: "DeleteNoteTemplate",
          accountnumber: accountNumber,
          patientID: patientId,
          templateID: template.id,
        },
      };
      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", payload, {
          headers: { "Content-Type": "application/json;" },
        });
        if (res?.data?.status !== "success") {
          throw new Error(res?.data?.message || "Template delete failed");
        }
        this.noteTemplateSelector = "Templates";
        await this.loadTemplates();
        this.closeTemplateModal();
      } catch (err) {
        console.error("Unable to delete template", err);
        alert("Unable to delete the template. Please try again.");
      } finally {
        this.templateSaving = false;
      }
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    dragNote(el) {
      // console.log(el)
      var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
      
      const dragHeader = document.getElementById("dragHeader" + this.patientKey);
      if (!dragHeader) {
        console.warn('Drag header element not found');
        return;
      }
      
      dragHeader.onmousedown = dragMouseDown;

      function dragMouseDown(e) {
        // e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        // e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        el.style.top = el.offsetTop - pos2 + "px";
        el.style.left = el.offsetLeft - pos1 + "px";
      }

      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.runningTime += 1;
      }, 1000);
    },
    showTime() {
      let time = this.runningTime;
      let hours = Math.floor(time / 3600);
      let newTime = time % 3600;
      let minutes = Math.floor(newTime / 60);
      let seconds = newTime % 60;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      return "" + hours + ":" + minutes + ":" + seconds;
    },
    filterNotes() {
      if (window.innerWidth <= 575) {
        return this.noteList.filter((note) => note.type == this.noteType).slice(0, 3);
      }
      return this.noteList.filter((note) => note.type == this.noteType).slice(0, 5);
    },
    // After note save: email/SMS selected groups + individuals by preference.
    async sendGroupNotifications() {
      if (!this.hasNotifySelection || !this.resolvedNotifyMembers.length) return;

      // Resolve patient / account / writer for the notify payload.
      const patientId = String(
        this.patient.patient_id || this.patient.psersonalID || this.patient.id || ""
      ).trim();
      const accountNumber = String(
        this.allData?.patient?.externId2 || this.patient.externId2 || ""
      ).trim();
      const writerName = this.sessionActor.displayName;

      try {
        // One backend call handles group ids and explicit member ids together.
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Provider: {
              API_Meth: "SendNoteGroupNotifications",
              accountnumber: accountNumber,
              group_ids: this.notifyGroupIdsForApi,
              member_unique_IDs: this.notifyMemberIdsForApi,
              writerName,
              dest: "professional-notes",
              // Exclude the patient so they aren't notified as a "group member".
              patient_unique_ID: patientId,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );

        const payload = res.data || {};
        // Treat any success-shaped response as OK.
        const ok =
          payload.message === "NotificationsSent" ||
          payload.code === 1 ||
          String(payload.status || "").toLowerCase().includes("success");

        if (ok) {
          alert(
            "The note for " +
              this.patient.first_name +
              " " +
              this.patient.lastname +
              " has been saved. Notifications have been sent."
          );
          return true;
        } else {
          // Note already persisted; only the notify step failed.
          alert(
            "The note was saved, but there was an error sending notifications. Please alert an administrator."
          );
          return false;
        }
      } catch (error) {
        console.error("Error sending group notifications:", error);
        alert(
          "The note was saved, but there was an error sending notifications. Please alert an administrator."
        );
        return false;
      }
    },
    // The whole note, so the overlay can show its videos beside its text.
    showContents(note) {
      this.popupNote = note;
      this.popupText = note.pnotes;
    },
    // "2 videos" on a note that has some to watch; "" on one that has none.
    noteVideoCountLabel(note) {
      return videoCountLabel(noteVideoCount(note));
    },
    showContentsMobile(text, index) {
      let noteContent = document.getElementById("notecontent" + index);
      if (noteContent.style.display != "block") {
        noteContent.style.display = "block";
      } else {
        noteContent.style.display = "none";
      }
    },
    closeContents() {
      this.popupText = "";
      this.popupNote = null;
    },
    // Load patient-owned subgroups (+ members) for the combined Notify picker.
    async getGroups() {
      const patientId = String(
        this.patient.patient_id || this.patient.psersonalID || this.patient.id || ""
      ).trim();
      const accountNumber = String(
        this.allData?.patient?.externId2 || this.patient.externId2 || ""
      ).trim();
      // Can't load team without both ids.
      if (!patientId || !accountNumber) {
        this.groupList = [];
        return;
      }

      try {
        // Same team endpoint used by messaging — returns groups with member contact fields.
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Messages: {
              API_Meth: "GetPatientTeamForMessaging",
              accountnumber: accountNumber,
              patient_unique_ID: patientId,
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        const payload = res.data;
        const ok = payload && String(payload.status || "").toLowerCase().includes("success");
        // Store groups (+ nested members) for the combined Notify picker.
        this.groupList = ok && Array.isArray(payload.data) ? payload.data : [];
      } catch (error) {
        console.error("Error loading patient groups:", error);
        this.groupList = []; // fail soft — picker just stays empty
      }
    },
    async getAllNotes() {
      const pid = this.patient.patient_id || this.patient.psersonalID || this.patient.id;
      if (!pid) return;
      let content = {
        Note: {
          API_Meth: "GetAllNotes",
          patientID: pid,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.noteList = res.data.data || [];
        });
    },
    // A draft is the note's text only (updateNotes): its videos are not in it, and
    // stay in this popup, still uploaded, for as long as the page is open.
    draftNote() {
      let note = document.getElementById("note__popup" + (this.patient.patient_id || this.patient.psersonalID || this.patient.id));
      if (note) {
        note.style.display = "none";
      }
      this.$emit('closeNote');
      let noteDraft = {
        userid: this.user.id,
        patientid: (this.patient.patient_id || this.patient.psersonalID || this.patient.id) + "",
        timestamps: {
          startDt: this.startDt,
          endDt: this.endDt,
          startTime: this.startTime,
          endTime: this.endTime,
          // provname: this.provsignature,
          // provsigdt: this.provsigdt,
        },
        draft: this.message,
      };
      updateNotes(noteDraft).then((res) => {
        // console.log(res)
      });
      this.noteTemplateSelector = "Templates";
      this.runningTime = 0;
      clearInterval(this.interval);
    },
    removeNote() {
      let note = document.getElementById("note__popup" + (this.patient.patient_id || this.patient.psersonalID || this.patient.id));
      if (note) {
        note.style.display = "none";
      }
      this.$emit('closeNote');
      this.message = "";
      // Cancel is the end of this note: its unclaimed videos are cancelled or discarded.
      this.discardNoteVideos();
      this.startTime = this.endTime = null;
      let today = new Date().toISOString().substring(0, 10);
      this.startDt = today;
      this.endDt = today;
      this.provsigdt = today;
      this.noteTemplateSelector = "Templates";
      let draftDel = {
        userid: this.user.id,
        patientid: (this.patient.patient_id || this.patient.psersonalID || this.patient.id) + "",
      };
      deleteNotes(draftDel).then((res) => {
        // console.log(res)
      });
      this.runningTime = 0;
      clearInterval(this.interval);
    },
    showOrder() {
      let order = document.getElementById("order__popup" + this.patient.id);
      order.style.display = "flex";
    },
    async saveNote() {
      // console.log(this.message, this.notify)
    
      console.log("PATIENT INFO");
      console.log(this.patient);
      if (!this.message) {
        alert("There is no message to save.");
        return;
      }
      // Save is disabled while a video is going up; this is for whatever else calls it.
      if (this.noteVideosBusy) {
        alert(NOTE_VIDEO_UPLOADING_TEXT);
        return;
      }
      let loader = this.$loading.show(
        {},
        { after: () => h("div", {}, "Saving your note...") }
      );
      const todayISO = new Date().toISOString().substring(0, 10);
      const provsigdtSaved =
        this.provsigdt && String(this.provsigdt).trim() !== ""
          ? String(this.provsigdt).trim()
          : todayISO;
      let post = {
        API_Meth: "SavePatientNote",
        accountnumber:
          this.allData?.patient?.externId2 ||
          this.sessionActor.accountnumber ||
          "",
        subaccountnumber: this.sessionActor.unique_ID || "",
        PatientNote: this.message,
        patientID: notePatientId(this.patient),
        pname: this.patient.first_name + " " + this.patient.lastname,
        notify: this.notify,
        notifysms:this.notifysms,
        email: this.pEmail ||this.patient.email || null,
        phone:this.patient.phone1 ||this.patient.contact_number || '',
        name: this.sessionActor.displayName,
        startDt: this.startDt,
        endDt: this.endDt,
        startTime: this.startTime,
        endTime: this.endTime,
        provsignature: this.provsignature,
        provsigdt: provsigdtSaved,
        type: this.noteType,
        timeLength:
          this.noteType == "9898X" || this.noteType == "9945X" ? this.runningTime : null,
      };
      try {
        // The same JSON POST as ever; a note with videos also names them (notesApi).
        const result = await postNote(post, {
          attachmentUids: this.noteVideoUids(),
          visibleUids: this.noteVideoVisibleUids(),
        });
        if (result.ok) {
          // A saved note can come with something to say: keyon could not attach
          // some videos, or the notification about the note did not go out. It
          // is saved either way, so it is cleared and closed like any other.
          if (this.hasNotifySelection && this.resolvedNotifyMembers.length) {
            if (result.message) alert(result.message);
            await this.sendGroupNotifications();
          } else if (result.message) {
            alert(result.message);
          } else {
            alert(
              "The note for " +
                this.patient.first_name +
                " " +
                this.patient.lastname +
                " has been saved."
            );
          }
          this.finishNoteVideos(result);
          // Close the same way whether or not anyone was notified.
          const possibleIds = [
            this.patient.patient_id,
            this.patient.psersonalID,
            this.patient.id,
            this.patient.externId
          ];
          for (const id of possibleIds) {
            if (id) {
              const note = document.getElementById("note__popup" + id);
              if (note) {
                note.style.display = "none";
                break;
              }
            }
          }
          this.noteTemplateSelector = "Templates";
          this.message = "";
          this.selectedNotifyGroupIds = [];
          this.selectedNotifyMemberIds = [];
          this.notifyPickerExpanded = false;
          this.startTime = this.endTime = null;
          let today = new Date().toISOString().substring(0, 10);
          this.startDt = today;
          this.endDt = today;
          this.provsigdt = today;
          this.$emit("note-saved");
          this.$emit("closeNote");
        } else {
          // Nothing is cleared. Refused: keyon's own sentence, if it had one.
          // Saved, but an older keyon ignored the videos: the sentence that
          // says so; the text and the uploads stay, so the person decides.
          alert(
            result.message ||
              "There was an error in saving the note. Please try again or contact a website administrator."
          );
        }
      } catch (error) {
        console.error("Error saving note:", error);
        alert(
          "There was an error in saving the note. Please try again or contact a website administrator."
        );
      } finally {
        // Always hide the loader, even if there's an error
        if (loader) {
          loader.hide();
          loader = null;
        }
        let draftDel = {
          userid: this.user.id,
          patientid: (this.patient.patient_id || this.patient.psersonalID || this.patient.id) + "",
        };
        deleteNotes(draftDel).then((res) => {
          // console.log(res)
        });
        this.getAllNotes();
        this.runningTime = 0;
        clearInterval(this.interval);
      }
    },
  },
};
</script>

<style scoped>
/*@import "/keyon"; */
@import url("https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Satisfy&display=swap");
.satisfy-regular {
  font-family: "Satisfy", serif;
  font-weight: 400;
  font-style: normal;
  font-size: 22px;
}

.mboxtitle {
  display: flex;
}

.notesTitle {
  margin-left: 5%;
}

.startDateTime,
.endDateTime {
  display: flex;
  justify-content: flex-end;
}

.header-title {
  cursor: move;
}

.header-first {
  display: flex;
  justify-content: space-between;
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 1%;
}

.text-popup {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.text-content {
  background-color: #e6faff;
  padding: 20px;
  border-radius: 5px;
  z-index: 99999;
  text-align: left;
}

.outer-container {
  overflow: scroll;
  overflow-wrap: anywhere;
  max-height: 80%;
  width: 100%;
}

.btn-group {
  width: 100%;
}

.template-action-row {
  display: inline-flex;
  gap: 8px;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: middle;
}

.mobile-template-action-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin: 10px 0 0 0;
  box-sizing: border-box;
}

.template-action-btn {
  flex: 0 1 auto;
  min-height: 34px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background-color: #ffffff;
  color: #1f2937;
  padding: 0 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.template-action-btn:hover:not(:disabled) {
  background-color: #f8fafc;
  border-color: #94a3b8;
}

.template-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.template-action-btn--delete {
  border-color: #dc3545;
  background-color: #dc3545;
  color: #ffffff;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.template-action-btn--delete:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #c82333;
}

.template-modal-content {
  /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
  width: min(420px, 92vw);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.template-name-input {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px 10px;
}

.template-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.template-modal-btn {
  border: none;
  border-radius: 5px;
  color: #fff;
  padding: 8px 12px;
  cursor: pointer;
}

.template-modal-btn.cancel {
  background-color: #6c757d;
}

.template-modal-btn.save {
  background-color: #007bff;
}

.template-modal-btn.delete {
  background-color: #dc3545;
  margin-right: auto;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notebtn {
  background-color: #007bff !important;
}

.noteList-videos {
  margin-left: 12px;
  font-size: 0.8em;
}

/* Save waits for a video that is still uploading. */
#msgbtn:disabled,
.Mobile-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.noteTimer {
  float: left;
  margin-left: 1%;
  margin-top: 1%;
}

.msboxwrapper .container {
  box-sizing: border-box;
  max-width: 100%;
}

.msboxwrapper .msgbox {
  box-sizing: border-box;
  max-width: 100%;
}

.note-footer-row {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.note-footer-left,
.note-footer-right {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.note-footer-left {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.note-footer-right {
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  flex: 1 1 auto;
  max-width: 100%;
}

.note-notify-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  margin-right: 6px;
  flex: 0 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
}

.note-notify-label-row,
.note-notify-check-row {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  min-width: 0;
}

.note-notify-label {
  margin: 0;
  padding: 0 2px;
  text-align: center;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.15;
  white-space: nowrap;
  cursor: pointer;
}

.note-notify-check-cell {
  flex: 1 1 0;
  min-width: 0;
  max-width: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.note-footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  min-width: 0;
}

/* Global keyon.scss fixes .modalbtn etc. at 130px width — allow shrink so Save stays inside the popup. */
.note-footer-actions .modalbtn,
.note-footer-actions .modalcancelbtn,
.note-footer-actions .modaldraftbtn {
  width: auto;
  min-width: 5.5rem;
  max-width: 100%;
  flex: 0 1 auto;
}

.template-footer-btn {
  transition: opacity 0.15s ease, filter 0.15s ease;
}

.template-footer-btn:not(.template-footer-btn--disabled) {
  opacity: 0.95;
  filter: brightness(1.03);
}

.template-footer-btn--disabled {
  opacity: 0.45 !important;
  filter: grayscale(0.25) brightness(0.92);
  cursor: not-allowed;
}

.template-footer-btn--delete {
  background-color: #dc3545 !important;
  color: #ffffff;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ql-editor {
  font-size: 150%;
}

.Mobile-container {
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  margin: auto;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  overflow-x: hidden;
}

.Mobile-title {
  text-align: center;
  color: #007bff;
  margin-bottom: 20px;
  font-size: 1.5em;
}

.Mobile-form-group {
  margin-bottom: 15px;
}

.Mobile-form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

/* Mobile popup: label + control on one row to reduce vertical height. */
.Mobile-container .Mobile-form-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  box-sizing: border-box;
}

.Mobile-container .Mobile-form-row > label {
  display: block;
  margin: 0;
  flex: 0 0 auto;
  white-space: nowrap;
  min-width: 5.75rem;
}

.Mobile-container .Mobile-form-row > .Mobile-select,
.Mobile-container .Mobile-form-row > .Mobile-input,
.Mobile-container .Mobile-form-row > .Mobile-signature-input,
.Mobile-container .Mobile-form-row > .Mobile-inline-inputs {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
  margin: 0;
}

.Mobile-inline-inputs {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.Mobile-inline-inputs .Mobile-input {
  flex: 1 1 0;
  min-width: 0;
  width: auto;
}

.Mobile-input,
.Mobile-select,
.Mobile-textarea {
  width: 100%;
  padding: 10px;
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  font-size: 1em;
  box-sizing: border-box;
}

.Mobile-input,
.Mobile-select {
  border: 1px solid #ccc;
}

.Mobile-input:focus,
.Mobile-select:focus,
.Mobile-textarea:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.Mobile-button-group {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5%;
}

.Mobile-button {
  flex: 1;
  margin: 0 5px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 1em;
  cursor: pointer;
}

.Mobile-cancel {
  background-color: #6c757d;
}

.Mobile-save-draft {
  background-color: #007bff;
}

.Mobile-save {
  background-color: #28a745;
}

.Mobile-note-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Mobile-note-control {
  display: flex;
  align-items: center;
}

#expandButton {
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  padding: 5px 10px;
  border: none;
  font-size: 1.2em;
  cursor: pointer;
  margin-right: 10px;
}

.Mobile-create-note {
  font-size: 1em;
  color: #007bff;
}

.Mobile-notify-block {
  padding: 10px 0 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Mobile-notify-labels,
.Mobile-notify-checks {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.Mobile-notify-labels label {
  margin: 0;
  min-width: 0;
  text-align: center;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.15;
  white-space: nowrap;
}

.Mobile-notify-check-cell {
  flex: 1 1 0;
  min-width: 0;
  max-width: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Mobile-note-content-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: white;
  border: none;
  padding: 20px;
  box-sizing: border-box;
  font-size: 1.2em;
  overflow-y: auto;
}

.Mobile-note-content-fullscreen:focus {
  outline: none;
}

.Mobile-minimize-button {
  position: fixed;
  top: 10px;
  right: 10px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 1.5em;
  cursor: pointer;
  z-index: 1001;
}

.mobile-modal {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.mobile-modal-content {
  /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
  height: 90%;
  margin: 10% auto;
  padding: 20px;
  width: 90%;
  max-width: 500px;
}
.mobile-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-modal-header h2 {
  margin: 0;
}

.mobile-close-modal {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}

.mobile-textarea-fullscreen {
  width: 100%;
  height: 90%;
  padding: 10px;
  border-radius: 5px;
  /* border: 1px solid #ccc; */
  font-size: 1em;
  box-sizing: border-box;
}
.mobile-modal-name {
  font-size: 1.25rem;
}

.Mobile-form-group h3 {
  font-size: 1em;
  margin-bottom: 10px;
  color: #007bff;
  font-weight: bold;
  text-align: center;
}

.mobile-note-item {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  background-color: #e0f7fa;
  padding: 8px;
  margin-bottom: 5px;
  border-radius: 5px;
}

.note-meta-mobile {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.mobile-note-content {
  display: none;
  padding: 10px;
  margin-top: 10px;
  background-color: #fff;
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  max-height: 300px;
  overflow-y: scroll;
}

.mobileNoteTimer {
  text-align: center;
}

.Mobile-container .Mobile-note-signature {
  padding: 0;
}

.Mobile-container .Mobile-note-signature .provname,
.Mobile-container .Mobile-note-signature .provsigdate {
  margin-bottom: 12px;
}

.Mobile-container .Mobile-note-signature .provname label,
.Mobile-container .Mobile-note-signature .provsigdate label {
  display: block;
  margin: 0;
  font-weight: bold;
}

.Mobile-container .Mobile-signature-input,
.Mobile-container .Mobile-note-signature .provsigdate input[type="date"] {
  width: auto;
  margin-left: 0;
  box-sizing: border-box;
}

.Mobile-container .note-notify-stack {
  width: 100%;
}

.note-template-notify-row {
  /* Left templates | centered picker | right recipient list (fills open space). */
  clear: both;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  column-gap: 1rem;
  row-gap: 0.5rem;
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 3% 0.25rem 5%;
}

.note-template-notify-row .template-chooser {
  /* Override global float so grid placement works; stay left in column 1. */
  float: none;
  justify-self: start;
  align-self: center;
  width: auto;
  min-width: 9rem;
  max-width: 14rem;
  margin: 0;
}

.notify-pickers {
  /* Middle grid column centers the picker on the modal. */
  float: none;
  width: auto;
  margin: 0;
  justify-self: center;
  display: block;
  box-sizing: border-box;
}

.notify-picker {
  min-width: 12rem;
  max-width: 22rem;
  width: 18rem;
}

.notify-picker--combined {
  max-width: 22rem;
  width: 18rem;
}

.notify-recipients-label {
  display: block;
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: left;
}

.notify-recipients-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.notify-recipients-header--mobile {
  margin-bottom: 0.35rem;
}

.notify-recipients-header--mobile label {
  margin: 0;
}

.notify-recipients-toggle {
  flex-shrink: 0;
  padding: 0.2rem 0.55rem;
  border: 1px solid #0c8687;
  border-radius: 4px;
  background: #fff;
  color: #0c8687;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.notify-recipients-toggle:hover {
  background: #e8f4f4;
}

.notify-recipients-toggle--mobile {
  font-size: 0.8rem;
  padding: 0.25rem 0.65rem;
}

.notify-combined {
  width: 100%;
  max-height: 9.5rem;
  overflow-y: auto;
  padding: 0.35rem 0.4rem;
  font-size: 0.8rem;
  line-height: 1.3;
  border: 1px solid #9aa4af;
  border-radius: 4px;
  background: #fff;
  text-align: left;
  box-sizing: border-box;
}

/* Plaintext recipient preview to the right of the picker (no input chrome). */
.notify-selection-panel {
  justify-self: stretch;
  min-width: 0;
  margin-top: 1.35rem; /* align with the picker box under the Notify label */
  text-align: left;
  box-sizing: border-box;
}

.notify-selection-panel--collapsed {
  margin-top: 0;
}

.notify-selection-panel__text {
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
  line-height: 1.35;
  color: #1f2937;
}

.notify-selection-panel__text strong {
  font-weight: 700;
}

.notify-selection-panel__text--muted {
  color: #6b7280;
  font-weight: 400;
}

.notify-combined--mobile {
  max-height: 14rem;
  min-height: 5rem;
}

.notify-combined__empty,
.notify-combined__no-members {
  margin: 0.15rem 0 0.25rem;
  color: #6b7280;
  font-size: 0.75rem;
}

.notify-combined__group + .notify-combined__group {
  margin-top: 0.45rem;
  padding-top: 0.35rem;
  border-top: 1px solid #e5e7eb;
}

.notify-combined__group-row,
.notify-combined__member-row {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  margin: 0;
  font-weight: 400;
  cursor: pointer;
}

.notify-combined__group-row {
  font-weight: 600;
}

.notify-combined__group-name {
  flex: 1 1 auto;
}

.notify-combined__badge {
  flex: 0 0 auto;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  padding: 0 0.3rem;
  line-height: 1.4;
}

.notify-combined__member-row {
  margin-left: 1.15rem;
  margin-top: 0.15rem;
  color: #374151;
}

.notify-combined__member-row--covered {
  color: #6b7280;
  cursor: default;
}

.notify-combined input[type="checkbox"] {
  margin-top: 0.15rem;
  flex: 0 0 auto;
}

.group-members-preview {
  /* Kept for mobile preview below the picker. */
  margin: 0.25rem 3% 0 5%;
  padding: 0;
  background: none;
  border: none;
  font-size: 0.75rem;
  line-height: 1.3;
  text-align: left;
  max-height: 2.6rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.group-members-preview--mobile {
  margin-top: 0.5rem;
  max-height: none;
  -webkit-line-clamp: unset;
  display: block;
}

.note-signature {
  clear: both;
  display: flex;
  justify-content: flex-start;
  text-align: left;
  padding: 10px;
}
.provname {
  margin-bottom: 15px;
}
.provname label {
  margin-right: 10px;
}
.provname input[type="text"] {
  width: 280px;

  border-radius: 4px;
  height: 35px;
  border-right-style: none;
  border-left-style: none;
  border-top-style: none;
  background-color: #dfdddd;
}
.provsigdate label {
  margin-right: 10px;
}
.provsigdate input[type="date"] {
  width: 280px;
  margin-left: 28px;
  border-radius: 4px;
  height: 35px;
  border-right-style: none;
  border-left-style: none;
  border-top-style: none;
  background-color: #dfdddd;
}

.note-editor-shell {
  height: 300px;
  min-height: 200px;
  max-height: 70vh;
  resize: vertical;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.note-editor-shell :deep(.p-editor) {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
}

.note-editor-shell :deep(.p-editor-toolbar) {
  flex-shrink: 0;
}

.note-editor-shell :deep(.p-editor-content),
.note-editor-shell :deep(.ql-container) {
  flex: 1 1 auto;
  min-height: 0;
  height: auto !important;
}

.msboxwrapper {
  z-index: 10000 !important;
  max-height: 90vh;
  overflow-y: auto;
  /* Stronger outline so the note popup separates from the dimmed backdrop, esp. top/bottom. */
  border: 2px solid #1f2937;
  border-top-width: 3px;
  border-bottom-width: 3px;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.55),
    0 12px 32px rgba(0, 0, 0, 0.45);
}
</style>
